"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FairyMagic = exports.MagitechMagic = exports.SpecialHolyMagic = exports.Magic = exports.MagicJob = void 0;
const static_1 = require("./static");
const Magics_json_1 = __importDefault(require("/node_modules/buff-manager/resources/Magics.json"));
// 《魔力強化》はpowerAddに既に入っているものとする
class MagicJob {
    constructor(name, level, status, powerAdd, castAdd, damageAdd, powerTotal, isOwn, faith = '') {
        this.powerAdd = 0;
        this.damageAdd = 0;
        this.castAdd = 0;
        this.faith = '';
        this.magics = [];
        this.isOwn = false;
        this.status = '';
        this.powerTotal = 0;
        this.castTotal = 0;
        this.name = name;
        this.level = level;
        this.status = status;
        this.powerAdd = powerAdd;
        this.castAdd = castAdd;
        this.damageAdd = damageAdd;
        this.isOwn = isOwn;
        this.powerTotal = powerTotal;
        this.castTotal = powerTotal + castAdd;
        this.faith = faith;
        this.magics = Magic.getMagics(name, level, faith);
    }
    convertCommandCast({ addCommandsShortcut, noStatus, }) {
        const BUFF_ALL = '{' + static_1.BuffLabel.ALL + '}';
        const BUFF_ACT = '{' + static_1.BuffLabel.ACT + '}';
        const BUFF_MAG_POWER = '{' + static_1.BuffLabel.MAG_POWER + '}';
        const BUFF_MAG_CAST = '{' + static_1.BuffLabel.MAG_CAST + '}';
        const command = [];
        let description = '';
        if (this.name === static_1.JobLabel.bard) {
            if (addCommandsShortcut) {
                description = `【演奏判定】@${static_1.CommandShortcut.SONG}`;
            }
            else {
                description = `【演奏判定】`;
            }
        }
        else if (this.name === static_1.JobLabel.alchemist) {
            if (addCommandsShortcut) {
                description = `【賦術判定】@${static_1.CommandShortcut.ALCHEMY}`;
            }
            else {
                description = `【賦術判定】`;
            }
        }
        else {
            if (addCommandsShortcut) {
                description = `【${this.name}魔法行使判定】@${static_1.CommandShortcut.MAGIC}`;
            }
            else {
                description = `【${this.name}魔法行使判定】`;
            }
        }
        command.push(`2d`);
        if (noStatus) {
            command.push(this.castTotal.toString());
        }
        else {
            command.push(`{${this.name}}`);
            if (this.isOwn)
                command.push(`(({${this.status}}+2)/6)`);
            else
                command.push(`(({${this.status}})/6)`);
            if (this.powerAdd > 0)
                command.push(this.powerAdd.toString());
            if (this.castAdd > 0)
                command.push(this.castAdd.toString());
            if (this.name !== static_1.JobLabel.bard && this.name !== static_1.JobLabel.alchemist) { // 魔力はバードとアルケミストは除外
                command.push(BUFF_MAG_POWER);
                command.push(BUFF_MAG_CAST);
            }
            command.push(BUFF_ACT);
            command.push(BUFF_ALL);
        }
        return command.join('+') + ' ' + description;
    }
    convertCommandsDamage({ rates, jobLabel, isHeal = false, addCommandsShortcut = true, noStatus, }) {
        const BUFF_MAG_POWER = '{' + static_1.BuffLabel.MAG_POWER + '}';
        const BUFF_MAG_DAMAGE = '{' + static_1.BuffLabel.MAG_DAMAGE + '}';
        // const BUFF_MAG_CRITCAL : string = '{' + BuffLabel.MAG_CRITCAL + '}';
        const commands = [];
        // 通常
        rates.forEach(rate => {
            const command = [];
            const extra = [];
            if (isHeal)
                command.push(`k${rate}[13]`);
            // else command.push('k'+rate+'[(10+'+BUFF_MAG_CRITCAL+')]');
            else
                command.push(`k${rate}[10]`);
            if (noStatus) {
                command.push(this.powerTotal.toString());
            }
            else {
                command.push(`{${this.name}}`);
                if (this.isOwn)
                    command.push(`(({${this.status}}+2)/6)`);
                else
                    command.push(`(({${this.status}})/6)`);
                if (this.powerAdd > 0)
                    command.push(this.powerAdd.toString());
                command.push(BUFF_MAG_POWER);
                if (this.damageAdd > 0 && !isHeal)
                    extra.push(this.damageAdd.toString());
                if (!isHeal)
                    extra.push(BUFF_MAG_DAMAGE);
            }
            if (extra.length > 0) {
                if (addCommandsShortcut) {
                    //   commands.push(command.join('+') + `+(${extra.join('+')})` + ' ' + '【威力'+rate+(isHeal?'回復':'')+'】' + (isHeal?`@${CommandShortcut.HEAL}${rate}`:`@${CommandShortcut.DAMAGE}${rate}`));
                    commands.push(`${command.join('+')}+(${extra.join('+')}) 【威力${rate}${isHeal ? '回復' : ''}(${jobLabel})】@${isHeal ? static_1.CommandShortcut.HEAL : static_1.CommandShortcut.DAMAGE}${rate}`);
                }
                else {
                    commands.push(`${command.join('+')}+(${extra.join('+')}) 【威力${rate}${isHeal ? '回復' : ''}(${jobLabel})】`);
                }
            }
            else {
                if (addCommandsShortcut) {
                    commands.push(`${command.join('+')} 【威力${rate}${isHeal ? '回復' : ''}(${jobLabel})】@${isHeal ? static_1.CommandShortcut.HEAL : static_1.CommandShortcut.DAMAGE}${rate}`);
                }
                else {
                    commands.push(`${command.join('+')} 【威力${rate}${isHeal ? '回復' : ''}(${jobLabel})】`);
                }
            }
        });
        if (isHeal)
            return commands;
        // 半減
        rates.forEach(rate => {
            const command = [];
            const extra = [];
            command.push('k' + rate + '');
            if (noStatus) {
                command.push(this.powerTotal.toString());
                if (this.damageAdd > 0)
                    extra.push(this.damageAdd.toString());
            }
            else {
                command.push('{' + this.name + '}');
                if (this.isOwn)
                    command.push(`(({${this.status}}+2)/6)`);
                else
                    command.push(`(({${this.status}})/6)`);
                if (this.powerAdd > 0)
                    command.push(this.powerAdd.toString());
                command.push(BUFF_MAG_POWER);
                if (this.damageAdd > 0)
                    extra.push(this.damageAdd.toString());
                extra.push(BUFF_MAG_DAMAGE);
            }
            if (extra.length > 0) {
                if (addCommandsShortcut) {
                    commands.push(`${command.join('+')}h+(${extra.join('+')}) 【威力${rate}半減(${jobLabel})】@${static_1.CommandShortcut.DAMAGE_HALF}${rate},${static_1.CommandShortcut.DAMAGE_HALF_S}${rate}`);
                }
                else {
                    commands.push(`${command.join('+')}h+(${extra.join('+')}) 【威力${rate}半減(${jobLabel})】`);
                }
            }
            else {
                if (addCommandsShortcut) {
                    commands.push(`${command.join('+')}h 【威力${rate}半減(${jobLabel})】@${static_1.CommandShortcut.DAMAGE_HALF}${rate},${static_1.CommandShortcut.DAMAGE_HALF_S}${rate}`);
                }
                else {
                    commands.push(`${command.join('+')}h 【威力${rate}半減(${jobLabel})】`);
                }
            }
        });
        return commands;
    }
    static generateMagicJob(job, level) {
        return new MagicJob(job, level, '', 0, 0, 0, 0, false);
    }
    // 使えるであろう威力表の一覧を取得する
    // TODO 特殊神聖魔法は全部対応していないよ
    getMagicRates() {
        const rates = [];
        const healRates = [];
        switch (this.name) {
            case static_1.JobLabel.sorcerer:
                if (this.level >= 1)
                    rates.push(10);
                if (this.level >= 3)
                    rates.push(20);
                if (this.level >= 5)
                    rates.push(30);
                if (this.level >= 8)
                    rates.push(40);
                if (this.level >= 11)
                    rates.push(50);
                if (this.level >= 14)
                    rates.push(60);
                if (this.level >= 15)
                    rates.push(100);
                return [
                    {
                        type: 'normal',
                        rates: rates,
                    },
                ];
            case static_1.JobLabel.conjurer:
                if (this.level >= 1)
                    rates.push(0);
                if (this.level >= 7)
                    rates.push(10);
                if (this.level >= 8)
                    rates.push(20);
                if (this.level >= 9)
                    rates.push(30);
                if (this.level >= 2)
                    healRates.push(0);
                if (this.level >= 11)
                    healRates.push(30);
                return [
                    {
                        type: 'normal',
                        rates: rates,
                    },
                    {
                        type: 'heal',
                        rates: healRates,
                    },
                ];
            case static_1.JobLabel.priest:
                if (this.level >= 3)
                    rates.push(10);
                if (this.level >= 5)
                    rates.push(20);
                if (this.level >= 8)
                    rates.push(30);
                if (this.level >= 8)
                    rates.push(40);
                if (this.level >= 11)
                    rates.push(50);
                if (this.level >= 13)
                    rates.push(90);
                if (this.level >= 2)
                    healRates.push(10);
                if (this.level >= 5)
                    healRates.push(30);
                if (this.level >= 10)
                    healRates.push(50);
                if (this.level >= 13)
                    healRates.push(70);
                return [
                    {
                        type: 'normal',
                        rates: rates,
                    },
                    {
                        type: 'heal',
                        rates: healRates,
                    },
                ];
            case static_1.JobLabel.fairytamer:
                if (this.level >= 2)
                    rates.push(10);
                if (this.level >= 5)
                    rates.push(20);
                if (this.level >= 4)
                    rates.push(30);
                if (this.level >= 8)
                    rates.push(40);
                if (this.level >= 9)
                    rates.push(50);
                if (this.level >= 11)
                    rates.push(60);
                if (this.level >= 15)
                    rates.push(80);
                return [
                    {
                        type: 'normal',
                        rates: rates,
                    },
                ];
            case static_1.JobLabel.magitech:
                if (this.level >= 7)
                    rates.push(10);
                if (this.level >= 1)
                    rates.push(20);
                if (this.level >= 5)
                    rates.push(30);
                if (this.level >= 12)
                    rates.push(40);
                if (this.level >= 8)
                    rates.push(50);
                if (this.level >= 15)
                    rates.push(70);
                if (this.level >= 15)
                    rates.push(90);
                if (this.level >= 14)
                    rates.push(100);
                if (this.level >= 2)
                    healRates.push(0);
                if (this.level >= 10)
                    healRates.push(30);
                return [
                    {
                        type: 'normal',
                        rates: rates,
                    },
                    {
                        type: 'heal',
                        rates: healRates,
                    },
                ];
            case static_1.JobLabel.demonruler:
                if (this.level >= 3)
                    rates.push(10);
                if (this.level >= 2)
                    rates.push(20);
                if (this.level >= 15)
                    rates.push(30);
                if (this.level >= 9)
                    rates.push(40);
                if (this.level >= 14)
                    rates.push(70);
                return [
                    {
                        type: 'normal',
                        rates: rates,
                    },
                ];
            case static_1.JobLabel.druid:
                if (this.level >= 4)
                    rates.push(10);
                if (this.level >= 4)
                    rates.push(20);
                if (this.level >= 12)
                    rates.push(30);
                if (this.level >= 15)
                    rates.push(50);
                return [
                    {
                        type: 'normal',
                        rates: rates,
                    },
                ];
            case static_1.JobLabel.bard:
                if (this.level >= 1)
                    rates.push(10);
                if (this.level >= 5)
                    rates.push(20);
                if (this.level >= 10)
                    rates.push(30);
                if (this.level >= 1)
                    healRates.push(0);
                if (this.level >= 1)
                    healRates.push(20);
                if (this.level >= 5)
                    healRates.push(30);
                if (this.level >= 10)
                    healRates.push(40);
                return [
                    {
                        type: 'normal',
                        rates: rates,
                    },
                    {
                        type: 'heal',
                        rates: healRates,
                    },
                ];
            default:
                return [];
        }
    }
}
exports.MagicJob = MagicJob;
class Magic {
    constructor(job, rank, cost, ref, name, isQuick = false, exCost = '') {
        this.job = job;
        this.cost = cost;
        this.rank = rank;
        this.ref = ref;
        this.name = name;
        this.isQuick = isQuick;
        this.exCost = exCost;
    }
    convertCommand() {
        let head = '>';
        if (this.isQuick)
            head += '>';
        return `${head} [${this.rank}]【${this.name}】(MP${this.cost}${this.exCost}) ${this.ref}`;
    }
    static getMagics(job, level, faith) {
        return Magic.getAllMagicsByJSON().filter(magic => magic.job === job && magic.rank <= level)
            .filter(magic => !(magic.faith) || (!!faith ? faith : "").includes(magic.faith))
            .filter(magic => {
            return magic.type !== static_1.FairyMagicType.CHAOS
                || magic.type === static_1.FairyMagicType.CHAOS && magic.rank <= static_1.FairyMagicRankMap[level].all.chaos;
        });
    }
    static getAllMagicsByJSON() {
        const magics = [];
        Magics_json_1.default.forEach(magic => {
            if (magic.category === 'fairy') {
                magics.push(new FairyMagic(static_1.FairyMagicType.BASIC, magic.level, magic.mp, magic.memo, magic.name, magic.canQuick, magic.exCost.toString()));
            }
            else if (/^fairy\./.test(magic.category)) {
                magics.push(new FairyMagic(static_1.FairyMagicType[magic.category.slice('fairy.'.length).toUpperCase()], magic.level, magic.mp, magic.memo, magic.name, magic.canQuick, magic.exCost.toString()));
            }
            else if (/^priest\./.test(magic.category)) {
                if (magic.category === 'priest.primary'
                    || magic.category === 'priest.secondary') {
                    if (/\(/.test(magic.name)) {
                        return;
                    }
                    magics.push(new Magic(static_1.JobLabel.priest, magic.level, magic.mp, magic.memo, magic.name, magic.canQuick, magic.exCost.toString()));
                    return;
                }
                // console.log(God[magic.category.slice('priest.'.length).toUpperCase()]);
                magics.push(new SpecialHolyMagic(static_1.God[magic.category.slice('priest.'.length).toUpperCase()], magic.level, magic.mp, magic.memo, magic.name, magic.canQuick, magic.exCost.toString()));
            }
            else {
                magics.push(new Magic(static_1.JobLabel[magic.category], magic.level, magic.mp, magic.memo, magic.name, magic.canQuick, magic.exCost.toString()));
            }
        });
        return magics;
    }
}
exports.Magic = Magic;
class SpecialHolyMagic extends Magic {
    constructor(faith, rank, cost, ref, name, isQuick = false, exCost = '') {
        super(static_1.JobLabel.priest, rank, cost, ref, name, isQuick, exCost);
        this.faith = '';
        this.faith = faith;
    }
}
exports.SpecialHolyMagic = SpecialHolyMagic;
class MagitechMagic extends Magic {
    constructor(rank, cost, ref, name, isQuick, types, exCost = '') {
        super(static_1.JobLabel.magitech, rank, cost, ref, name, isQuick, exCost);
        this.magiSphereTypes = types;
    }
}
exports.MagitechMagic = MagitechMagic;
class FairyMagic extends Magic {
    constructor(type, rank, cost, ref, name, isQuick = false, exCost = '') {
        super(static_1.JobLabel.fairytamer, rank, cost, ref, name, isQuick, exCost);
        this.type = type;
    }
}
exports.FairyMagic = FairyMagic;
//# sourceMappingURL=magic.js.map